import { LicenseInfo } from '@mui/x-license-pro';
import { observer } from 'mobx-react-lite';
import '@app/styles/app.scss';
import { Providers as SetupProviders } from '@app/setup/setupProviders';
import { RouterProvider } from 'react-router-dom';
import { router } from '@app/routes';

LicenseInfo.setLicenseKey(
  '6092913f26587d0f2bf53d851a724f47Tz0xMDkzNjYsRT0xNzczMTg3MTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

export const App = observer(() => (
  <SetupProviders>
    <RouterProvider router={router} />
  </SetupProviders>
));
